import type { BillingType } from '@consts/company';

export const STATUS_COLOR_MAP: Record<PlanChangeStatus | 'Executed', 'success' | 'error' | 'warning' | 'info'> = {
    Approved: 'success',
    Rejected: 'error',
    Pending: 'warning',
    Executed: 'info',
};

export type PlanChangeStatus = 'Pending' | 'Approved' | 'Rejected' | 'Executed';

export interface PlanChangeRequest {
    PlanID: number;
    StationID: number;
    TargetPlanID: BillingType;
    CurrentPlanID: BillingType;
    CreatedByUserID: string;
    CreatedByUserEmail: string;
    Status: PlanChangeStatus;
    EffectiveDate: string;
    Justification?: string | null;
    LocationName: string;
    LocationID: number;
    CompanyName: string;
    CompanyID: number;
    SerialNumber: string;
}

// Recent activity adds a timestamp of the last status change
export interface RecentPlanChange extends PlanChangeRequest {
    LastStatusUpdate: string;
}

export interface PlanChangeResponse {
    Pending: PlanChangeRequest[];
    Approved: PlanChangeRequest[];
}
